/**
 * Format a date string to include both date and time
 * @param {string} dateString - The date string to format
 * @returns {string} Formatted date and time string
 */
export function formatDate(dateString) {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString() + ' ' + new Date(dateString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

/**
 * Format an event date string to include day of week and date
 * @param {string} dateString - The date string to format
 * @returns {string} Formatted day and date string
 */
export function formatEventDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayOfWeek = days[date.getDay()];
  return dayOfWeek + ' ' + date.toLocaleDateString();
}

/**
 * Format a currency amount to display with dollar sign and 2 decimal places
 * @param {number|string} amount - The amount to format
 * @returns {string} Formatted currency string
 */
export function formatCurrency(amount) {
  if (!amount) return '0.00';
  return parseFloat(amount).toFixed(2);
} 
/**
 * The booking widget stores a comeback offer's delivery option as the position
 * the customer picked in the menu's delivery list, so the value arrives as
 * "0" / "1" / "2" rather than a name.
 */
export const DELIVERY_LABELS = {
  0: 'Drop off',
  1: 'Pickup',
  2: 'On-site',
};

/**
 * Turn a stored delivery value into its label
 * @param {string|number|null} value - The delivery value on a comeback offer
 * @returns {string} The delivery label, or the raw value if it is not a known position
 */
export function formatDelivery(value) {
  if (value === null || value === undefined || value === '') return '';
  const label = DELIVERY_LABELS[Number(value)];
  return label || String(value);
}

/**
 * One change the customer made in Foxy's cart before paying, as a line of text
 * (checkoutChanges from the quotes and orders API).
 * @param {{type: string, name: string, from: *, to: *}} change
 * @returns {string} e.g. "Quantity: Menu #2: 50 → 40"
 */
export function formatCheckoutChange(change) {
  const name = change.name || change.code || 'Item';
  switch (change.type) {
    case 'removed':
      return `Removed: ${name} (was ${change.from})`;
    case 'added':
      return `Added: ${name} × ${change.to}`;
    case 'quantity_changed':
      return `Quantity: ${name}: ${change.from} → ${change.to}`;
    case 'price_changed':
      return `Price: ${name}: $${change.from} → $${change.to}`;
    case 'total_changed':
      return `Items total: $${change.from} → $${change.to}`;
    default:
      return `${name}: ${change.from} → ${change.to}`;
  }
}
